export default __webpack_public_path__ + "static/media/gallery-wip-neck_05.7f6af750.jpg";